import React, { useState } from 'react';
import * as Routes from '@/modules/routes';
import SPAButton from '../shared/SPAButton';
import ticketSummary from './ticketSummary';
import type { AssignmentSyncPayload } from './useAssignmentSyncState';

/** Copies a plain-text write-up of this assignment's sync for a ticket or a reply, with a link back. */
// The link is to the legacy mount whichever mount it was copied from: support managers read the ticket
// too, and the /sysadmin SPA refuses them.
const CopySummaryButton = ({ payload }: { payload: AssignmentSyncPayload }) => {
  const [copied, setCopied] = useState(false);

  const copy = () => {
    const url = `${window.location.origin}${Routes.admin_grade_sync_index_path()}/assignments/${payload.assignment.id}`;

    navigator.clipboard?.writeText(ticketSummary(payload, url)).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <SPAButton size="xs" type="button" variant="secondary" onClick={copy}>
      {copied ? 'Copied' : 'Copy summary'}
    </SPAButton>
  );
};

export default CopySummaryButton;
